import { styled } from 'linaria/react';

export const ComplimentaryProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-250);
  width: 100%;
`;
export const AddedProductsTitle = styled.div`
  margin: var(--space-400) 0 var(--space-300) 0;
`;
